export default __webpack_public_path__ + "static/media/setup-cronos2.7ffa4a0f.png";